/** Regole media uniformi per TUTTE le schede comune — solo materiale certificato 6amico. */

export function isWikipediaMediaUrl(url) {
  if (!url || typeof url !== "string") return false;
  const s = url.toLowerCase();
  return s.includes("wikimedia.org") || s.includes("wikipedia.org");
}

/** @deprecated Regola globale: trattare sempre come materiale proprio */
export function isOwnMaterialSlug(_slug) {
  return true;
}

export function isCertifiedMediaUrl(url) {
  if (!url || typeof url !== "string") return false;
  const s = url.trim();
  if (!s || isWikipediaMediaUrl(s)) return false;
  if (s.includes("/api/uploads/")) return true;
  if (s.includes("/wp-content/uploads/")) return true;
  if (s.startsWith("/hero/") || s.startsWith("/images/")) return true;
  return false;
}

export function stripWikipediaFromUrls(urls = []) {
  return urls.filter((u) => u && !isWikipediaMediaUrl(u));
}

export function certifiedGalleryUrls(urls = []) {
  const seen = new Set();
  const out = [];
  for (const raw of urls) {
    if (!raw || typeof raw !== "string") continue;
    const u = raw.trim();
    if (!u || isWikipediaMediaUrl(u) || seen.has(u)) continue;
    seen.add(u);
    out.push(u);
  }
  const admin = out.filter((u) => u.includes("/api/uploads/admin/"));
  const rest = out.filter(
    (u) => !u.includes("/api/uploads/admin/") && (isCertifiedMediaUrl(u) || u.includes("/api/uploads/")),
  );
  if (admin.length) {
    const merged = [...admin];
    for (const u of rest) {
      if (!merged.includes(u)) merged.push(u);
    }
    return merged;
  }
  return rest;
}
